export { default } from "ember-css-transitions/modifiers/css-transition";
